import { common_urls_cws2 } from 'src/environments/environment';

export const TAX_DEDUCTION_CERTIFICATE_BASE_ROUTE = 'tax-deduction-certificate';
export const TAX_DEDUCTION_CERTIFICATE_STEPPER_TRANSLATION_PREFIX = 'taxDeductionCertificate.stepper.';
export const TAX_DEDUCTION_CERTIFICATE_SCREEN_TYPE = TAX_DEDUCTION_CERTIFICATE_BASE_ROUTE;
export const TAX_DEDUCTION_CERTIFICATE_STEP_NAMES = ['step1', 'step2', 'step3'] as const;

export const TAX_DEDUCTION_CERTIFICATE_ROUTES = {
  DETAILS: 'details',
  REQUEST_INPUT: 'request-input',
  SUBMISSION: 'submission',
  CONFIRMATION: 'confirmation',
} as const;

export const TAX_DEDUCTION_CERTIFICATE_API = {
  LOAD: `${common_urls_cws2.bffBaseUrl_mvp3}/load/insurance-premium-deduction-certificate`,
  SUBMIT: `${common_urls_cws2.bffBaseUrl_mvp3}/submit/insurance-premium-deduction-certificate`,
} as const;

export const TAX_DEDUCTION_CERTIFICATE_RECIPIENT_NAME_MAX_LENGTH = 50;

// Full-width Kanji/Hiragana/Katakana/Roman letters, the katakana long-vowel mark (ー),
// the full-width hyphen (－), and half-/full-width spaces. Excludes numbers, symbols, and commas.
export const TAX_DEDUCTION_CERTIFICATE_RECIPIENT_NAME_ALLOWED_CHARACTERS_PATTERN =
  /^[\u3040-\u309F\u3400-\u4DBF\u4E00-\u9FFF\u30A1-\u30FA\u30FC\u3005\uFF21-\uFF3A\uFF41-\uFF5A\uFF0D \u3000]*$/;

// Requires exactly one half-width or full-width space between the surname and given name.
export const TAX_DEDUCTION_CERTIFICATE_RECIPIENT_NAME_DELIMITER_PATTERN = /^[^\s\u3000]+[ \u3000][^\s\u3000]+$/;

export const TAX_DEDUCTION_CERTIFICATE_STEP_INDEX = {
  DETAILS: 0,
  REQUEST_INPUT: 1,
  SUBMISSION: 2,
  CONFIRMATION: 2,
} as const;

export enum PolicyType {
  DIGITAL = 'DIGITAL',
  PAPER = 'PAPER',
}

export const TAX_DEDUCTION_CERTIFICATE_POLICY_TYPE = PolicyType;

export const TAX_DEDUCTION_CERTIFICATE_PAPER_POLICY_PA_CODES = ['0001'] as const;
